import React from "react";

function Chrome() {
  return (
    <>
      <h3>Change your default location settings on Computer</h3>
      <ol>
        <li>On your computer, open Chrome.</li>
        <li>
          At the top right, click More&nbsp;
          <img
            title="More"
            src="https://lh3.googleusercontent.com/E2q6Vj9j60Dw0Z6NZFEx5vSB9yoZJp7C8suuvQXVA_2weMCXstGD7JEvNrzX3wuQrPtL=w36-h36"
            alt="More"
            width="18"
            height="18"
          />
          &nbsp;
          <img
            title="and then"
            src="https://lh3.googleusercontent.com/3_l97rr0GvhSP2XV5OoCkV2ZDTIisAOczrSdzNCBxhIKWrjXjHucxNwocghoUa39gw=w36-h36"
            alt="and then"
            width="18"
            height="18"
          />
          &nbsp;<strong>Settings</strong>.
        </li>
        <li>
          Under "Privacy and security," click&nbsp;
          <strong>Site settings</strong>.
        </li>
        <li>
          Click&nbsp;<strong>Location</strong>.
        </li>
        <li>
          Turn&nbsp;<strong>Ask before accessing</strong>&nbsp;on or off.
        </li>
      </ol>
      <h3>Change your default location settings on Android</h3>
      <ol>
        <li>
          On your Android phone or tablet, open the Chrome app&nbsp;
          <img
            title="Chrome"
            src="https://lh3.googleusercontent.com/uSRJIFR8eDSfkfjB4tuohW_Lojbukra5FzyRMzLEz-wRjAKm_9v6NNS2MS49JxrhQ37L=w36-h36"
            alt="Chrome"
            width="18"
            height="18"
          />
          .
        </li>
        <li>
          To the right of the address bar, tap More&nbsp;
          <img
            title="More"
            src="https://lh3.googleusercontent.com/oLoRPrHJd7m46sWijX6zBWnEnfslP62AxJSwt5Nj0bNbpaYHz2pyscExleiofsH2kQ=h36"
            alt="More"
            width="Auto"
            height="18"
          />
          &nbsp;
          <img
            title="and then"
            src="https://lh3.googleusercontent.com/QbWcYKta5vh_4-OgUeFmK-JOB0YgLLoGh69P478nE6mKdfpWQniiBabjF7FVoCVXI0g=h36"
            alt="and then"
            width="auto"
            height="18"
          />
          &nbsp;<strong>Settings</strong>.
        </li>
        <li>
          Tap&nbsp;<strong>Site settings</strong>&nbsp;
          <img
            title="and then"
            src="https://lh3.googleusercontent.com/QbWcYKta5vh_4-OgUeFmK-JOB0YgLLoGh69P478nE6mKdfpWQniiBabjF7FVoCVXI0g=h36"
            alt="and then"
            width="auto"
            height="18"
          />
          &nbsp;<strong>Location</strong>.
        </li>
        <li>
          Turn&nbsp;<strong>Location</strong>&nbsp;on or off.
        </li>
      </ol>
      <p>
        To change the settings for a specific site, tap the site name listed
        below.
      </p>
      <h3>Change your default location settings on iPhone & iPad&nbsp;</h3>
      <ol>
        <li>On your iPhone or iPad, open the settings app.</li>
        <li>
          Find and tap&nbsp;<strong>Chrome</strong>.
        </li>
        <li>
          Tap&nbsp;<strong>Location</strong>.
        </li>
        <li>Choose the option you want as your default setting.</li>
      </ol>
    </>
  );
}

export default Chrome;
